import { z } from 'zod';

export const GcpRegionRegex = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*-[a-z0-9]*[0-9]$/;

export const GcpRegionSchema = z.string().trim().regex(GcpRegionRegex, {
  error: 'Vertex AI location must be a valid GCP region',
});
